"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.recording.active': '录音中',
    'conversation.recording.inactive': '录音未开始',
};
